import scrollDir from "scrolldir";
import {slideUp, slideDown} from 'es6-slide-up-down';
import findAncestor from "./findAncestor";

export default () => {

    const header = document.querySelector('.js-header');
    const chervons = document.querySelectorAll('.js-chervon');
    const hamburger = document.querySelector('.js-hamburger');

    function isMobile()
    {
        return window.innerWidth < 768;
    }

    if (hamburger) {
        hamburger.addEventListener('click', (e) => {
            e.preventDefault();
            if (header.classList.contains('header--opened')) {
                header.classList.remove('header--opened')
            } else {
                header.classList.add('header--opened')
            }
            return false;
        });
    }

    for (const chervon of chervons) {
        chervon.addEventListener('click', (e) => {
            e.preventDefault();
            if (isMobile()) {
                const li = findAncestor(chervon, 'li');
                const subNav = li.querySelector('.js-sub-nav');
                if (li.classList.contains('opened')) {
                    slideUp(subNav);
                    li.classList.remove('opened');
                } else {
                    slideDown(subNav);
                    li.classList.add('opened');
                }
            }
            return false;
        });
    }

    window.addEventListener('scroll', () => {

        header.classList.remove('header--opened');
        if (window.scrollY > 250) {
            header.classList.add('header--fixed');
        }
        // else {
        //     header.classList.add('header--fixed');
        // }

    });


    scrollDir();

}
